/**
 * Colorize console output
 * @param {!any} message 
 * @param {?string} color 
 * @returns {void}
 */
const clog = (message, color) => {
  let prepend = '[LOG]';
  switch (color) {
    case "start":
      color = "green";
      prepend = '[START]';
      break;
    case "end":
      color = "orange";
      prepend = '[END]';
      break;
    case "info":
      color = "cyan";
      prepend = '[INFO]';
      break;
    case "warn":
      color = "yellow";
      prepend = '[WARN]';
      break;
    case "error":
      color = "red";
      prepend = '[ERROR]';
      break;
    default:
      color = 'grey';
  }

  message = typeof message === 'string' ? message : JSON.stringify(message, null, 2);
  console.log(`%c${prepend} : ${message}`, `color:${color}`);
}

/**
 * Only spam console in debug mode
 * @param {!boolean} debug 
 * @returns {function}
 */
const getColorConsole = (debug) => {
  return (debug) ? clog : function() {};
}

export default getColorConsole;
